import {useCallback} from "react";
import PropTypes from "prop-types";
import UploadSTL from "components/Message/UploadSTL";
import UploadExtraSTL from "components/Message/UploadExtraSTL";
import TreatmentPlanned from "components/Message/TreatmentPlanned";
import TreatmentDeleted from "components/Message/TreatmentDeleted";
import LoadingMessage from "./LoadingMessage";
import GeneralMessage from "components/Message/GeneralMessage";
import OrderIncomplete from "components/Message/OrderIncomplete";
import {FormattedMessage} from "react-intl";
import messages from "./messages";
import OrderMessage from "./OrderMessage";
import PlanMessage from "./PlanMessage";

function MessagePatient({
  showPatient = false,
  activeMessage = {},
  onClose,
  onCloseMessage,
  isLoading = false,
  onRemakeRequest,
  remakeProductOrder,
  onResetRemakeProductOrder,
  onRefittingRequest,
  onResetRefittingRequest,
  reFittingPlannedTreatment,
}) {
  const renderMessageType = useCallback(
    message => {
      switch (message.type) {
        case 1:
          return (
            <GeneralMessage
              onCloseMessage={onCloseMessage}
              activeMessage={activeMessage}
              onClose={onClose}
              showPatient={showPatient}
            />
          );
        case 2:
          //Order Placed
          return (
            <OrderMessage
              onClose={onClose}
              activeMessage={message}
              onRemakeRequest={onRemakeRequest}
              remakeProductOrder={remakeProductOrder}
              onResetRemakeProductOrder={onResetRemakeProductOrder}
              showPatient={showPatient}
              title={<FormattedMessage {...messages.order_placed_title} />}
            />
          );

        case 3:
          // Order Changed
          return (
            <OrderMessage
              onClose={onClose}
              activeMessage={message}
              onRemakeRequest={onRemakeRequest}
              remakeProductOrder={remakeProductOrder}
              onResetRemakeProductOrder={onResetRemakeProductOrder}
              showPatient={showPatient}
              title={<FormattedMessage {...messages.order_changed_title} />}
            />
          );

        case 4:
          // Order message
          return (
            <OrderMessage
              onClose={onClose}
              onCloseMessage={onCloseMessage}
              activeMessage={message}
              onRemakeRequest={onRemakeRequest}
              remakeProductOrder={remakeProductOrder}
              onResetRemakeProductOrder={onResetRemakeProductOrder}
              showPatient={showPatient}
              title={<FormattedMessage {...messages.order_message} />}
            />
          );

        case 5:
          return (
            <UploadSTL
              onClose={onClose}
              onCloseMessage={onCloseMessage}
              activeMessage={message}
              showPatient={showPatient}
            />
          );

        case 6:
          return (
            <UploadExtraSTL
              onClose={onClose}
              onCloseMessage={onCloseMessage}
              activeMessage={message}
              showPatient={showPatient}
            />
          );

        case 7:
          return (
            <TreatmentPlanned
              onClose={onClose}
              activeMessage={message}
              showPatient={showPatient}
              title={<FormattedMessage {...messages.appointment_planned_title} />}
              onRefittingRequest={onRefittingRequest}
              onResetRefittingRequest={onResetRefittingRequest}
              reFittingPlannedTreatment={reFittingPlannedTreatment}
            />
          );
        case 8:
          return (
            <TreatmentPlanned
              onClose={onClose}
              activeMessage={message}
              showPatient={showPatient}
              title={<FormattedMessage {...messages.appointment_changed_title} />}
              onRefittingRequest={onRefittingRequest}
              onResetRefittingRequest={onResetRefittingRequest}
              reFittingPlannedTreatment={reFittingPlannedTreatment}
            />
          );
        case 9:
          return (
            <TreatmentDeleted
              onClose={onClose}
              activeMessage={message}
              showPatient={showPatient}
            />
          );
        case 10:
          return (
            <OrderIncomplete
              onClose={onClose}
              onCloseMessage={onCloseMessage}
              activeMessage={message}
              showPatient={showPatient}
            />
          );

        case 11:
          return (
            <PlanMessage
              onClose={onClose}
              onCloseMessage={onCloseMessage}
              activeMessage={message}
              showPatient={showPatient}
              title={<FormattedMessage {...messages.close_productplan_message} />}
              upperProductName={message?.productPlan?.productTypeConfiguration?.upperProductTypeName}
              lowerProductName={message?.productPlan?.productTypeConfiguration?.lowerProductTypeName}
              caseId={message?.productPlan?.caseId}
            />
          );

        case 12:
          return (
            <PlanMessage
              onClose={onClose}
              onCloseMessage={onCloseMessage}
              activeMessage={message}
              showPatient={showPatient}
              title={<FormattedMessage {...messages.close_treatmentplan_message} />}
              upperProductName={message?.treatmentPlan?.endProductTypeConfiguration?.upperEndProductTypeName}
              lowerProductName={message?.treatmentPlan?.endProductTypeConfiguration?.lowerEndProductTypeName}
              caseId={message?.treatmentPlan?.caseId}
            />
          );
        default:
          return <div />;
      }
    },
    [
      showPatient,
      onCloseMessage,
      activeMessage,
      onClose,
      onRemakeRequest,
      remakeProductOrder,
      onResetRemakeProductOrder,
      reFittingPlannedTreatment
    ],
  );

  if (isLoading) {
    return <LoadingMessage onClose={onClose} />;
  }

  return <div style={{background:'white',borderRadius:'17px'}}>{renderMessageType(activeMessage)}</div>;
}

MessagePatient.propTypes = {
  activeMessage: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onCloseMessage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  onRemakeRequest: PropTypes.func,
  onRefittingRequest: PropTypes.func,
  onResetRefittingRequest: PropTypes.func,
  remakeProductOrder: PropTypes.object,
  reFittingPlannedTreatment: PropTypes.object,
  onResetRemakeProductOrder: PropTypes.func,
  showPatient: PropTypes.bool,
};

export default MessagePatient;
